/**
 * Marken-Umschalter – snippets/brand-switcher.liquid
 *
 * Die aktive Marke wird serverseitig gesetzt. Auf Seiten ohne eindeutige
 * Zuordnung (data-brand-matched="false") wird hier die zuletzt besuchte
 * Marke aus einem Session-Cookie wiederhergestellt.
 */
(() => {
  const COOKIE_NAME = 'lia_brand_tab';

  const readCookie = () => {
    const entry = document.cookie.split('; ').find((c) => c.startsWith(`${COOKIE_NAME}=`));
    return entry ? decodeURIComponent(entry.split('=')[1]) : null;
  };

  const writeCookie = (value) => {
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;
  };

  const setActive = (nav, link) => {
    nav.querySelectorAll('.brand-nav__link').forEach((el) => {
      const isActive = el === link;
      el.closest('.brand-nav__item').classList.toggle('is-active', isActive);
      if (isActive) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });
  };

  const prefetch = (href) => {
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.href = href;
    document.head.appendChild(hint);
  };

  const init = (nav) => {
    if (nav.dataset.brandInit) return;
    nav.dataset.brandInit = 'true';

    nav.addEventListener('click', (event) => {
      const link = event.target.closest('[data-brand]');
      if (link) writeCookie(link.dataset.brand);
    });

    if (nav.dataset.brandMatched === 'true') {
      // Eindeutige Seite: Marke merken, damit neutrale Folgeseiten sie kennen
      const active = nav.querySelector('[aria-current][data-brand]');
      if (active) writeCookie(active.dataset.brand);
    } else {
      const saved = readCookie();
      const link = saved && [...nav.querySelectorAll('[data-brand]')].find((el) => el.dataset.brand === saved);
      if (link) setActive(nav, link);
    }

    nav.querySelectorAll('[data-prefetch]').forEach((el) => prefetch(el.href));
  };

  const initAll = () => document.querySelectorAll('[data-brand-switcher]').forEach(init);

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
